/** Query keys for dashboard endpoints. */
export const dashboardKeys = {
  all: () => ['dashboard'] as const,
  homeSummary: (filter: string, fromDate?: string, toDate?: string) =>
    ['dashboard', 'home-summary', filter, fromDate, toDate] as const,
} as const;
